import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useGetVendorsQuery } from "../../app/config/redux/slices/api/vendorApiSlice";

const VendorsList = () => {

      const [page, setPage] = useState(1);

      const { data, isLoading, error } = useGetVendorsQuery();
      const vendors = data?.data ?? [];
    const size = data?.total || 0;
    const totalPages = data?.last_page || 1;
    const currentPage = data?.current_page || 1;

    const handleNextPage = () => {
        if (data?.next_page_url) {
            setPage((page) => page + 1);
        }
    };

    const handlePrevPage = () => {
        if (data?.prev_page_url) {
            setPage((page) => (page > 1 ? page - 1 : page));
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

  return (
    <section className='vendors-list py-80'>
      <div className='container container-lg'>
        {/* <div className='flex-between flex-wrap gap-8 mb-40'>
          <span className='text-neutral-600 fw-medium px-40 py-12 rounded-pill border border-neutral-100'>
            Showing 1-20 of 85 results
          </span>
          <div className='flex-align gap-16'>
            <form
              action='#'
              className='search-form__wrapper position-relative d-block'
            >
              <input
                type='text'
                className='search-form__input common-input py-13 ps-16 pe-18 rounded-pill pe-44'
                placeholder='Search vendors by name or ID...'
              />
              <button
                type='submit'
                className='w-32 h-32 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8'
              >
                <i className='ph ph-magnifying-glass' />
              </button>
            </form>
            <div className='flex-align gap-8'>
              <span className='text-gray-900 flex-shrink-0'>Sort by:</span>
              <select className='common-input form-select rounded-pill border border-gray-100 d-inline-block ps-20 pe-36 h-48 py-0 fw-medium' defaultValue={1}>
                <option value={1}>Latest</option>
                <option value={1}>Old</option>
              </select>
            </div>
          </div>
        </div> */}
        <div className='row gy-4 vendor-card-wrapper'>
          {vendors?.map((vendor) => (
            <div className='col-xxl-3 col-lg-4 col-sm-6'>
              <div className='vendor-card text-center px-16 pb-24'>
                <div className=''>
                  <img
                    src={vendor.vendor.image}
                    alt=''
                    className='vendor-card__logo m-12'
                    style={{ width: '66px', height: '64px', objectFit: 'cover' }}
                  />
                  <h6 className='title mt-32'>
                    <Link to={`/shop?vendor=${vendor.id}`} className=''>
                      {vendor.name}
                    </Link>
                  </h6>
                  <span className='text-heading text-sm d-block'>
                    {vendor.email}
                  </span>
                  <Link
                    to={`/shop?vendor=${vendor.id}`}
                    className='bg-white text-neutral-600 hover-bg-main-600 hover-text-white rounded-pill py-6 px-16 text-12 mt-8'
                  >
                    {vendor.name}
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
            {/* Pagination Start */}
            <ul className="pagination flex-center flex-wrap gap-16">
                <li className={`page-item ${
                        !data?.prev_page_url ? "disabled" : ""
                    }`}
                >
                    <Link
                        className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                        onClick={handlePrevPage}
                        disabled={!data?.prev_page_url}
                    >
                        <i className="ph-bold ph-arrow-left" />
                    </Link>
                </li>
                {Array.from(
                { length: totalPages },
                (_, index) => index + 1
                ).map((pageNum) => (
                <li className={`page-item ${
                        pageNum === currentPage ? "active" : ""
                    }`}
                >
                    <Link
                        key={pageNum}
                        className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                        onClick={() => handlePageChange(pageNum)}
                    >
                        {pageNum}
                    </Link>
                </li>
                ))}
                <li className={`page-item ${
                        !data?.next_page_url ? "disabled" : ""
                    }`}
                >
                    <Link
                        className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                        onClick={handleNextPage}
                        disabled={!data?.next_page_url}
                    >
                        <i className="ph-bold ph-arrow-right" />
                    </Link>
                </li>
            </ul>
            {/* Pagination End */}
      </div>
    </section>
  );
};

export default VendorsList;
